import React from 'react';

const Hero = () => {
  return (
    <section
      id="hero"
      className="min-h-screen bg-slate-900 text-white flex flex-col items-center justify-center text-center px-4"
    >
      {/* Heading */}
      <h1 className="text-5xl md:text-6xl font-extrabold mb-4">Hello, I'm Ravi</h1>

      {/* Subheading */}
      <p className="text-lg md:text-xl max-w-2xl text-gray-300">
        DevOps Engineer building scalable cloud platforms, streamlining CI/CD pipelines, and ensuring secure, zero-downtime deployments.
      </p>

      {/* Brag line */}
      <p className="text-sm text-green-400 mt-4">
        🚀 Delivered 50+ production deployments across AWS & GCP
      </p>

      {/* Tech Stack Icons */}
      <div className="flex gap-4 mt-6 flex-wrap justify-center">
        <img src="/icons/aws.svg" alt="AWS" className="h-8" />
        <img src="/icons/docker.png" alt="Docker" className="h-8" />
        <img src="/icons/k8s.svg" alt="Kubernetes" className="h-8" />
        <img src="/icons/terraform.png" alt="Terraform" className="h-8" />
        <img src="/icons/gitlab.png" alt="GitLab" className="h-8" />
        <img src="/icons/helm.webp" alt="Helm" className="h-8" />
      </div>

      {/* Buttons */}
      <div className="mt-8 flex gap-4">
        <a
          href="#contact"
          className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md"
        >
          Get in touch
        </a>
        <a
          href="#projects"
          className="px-6 py-2 border border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white rounded-md"
        >
          View Projects
        </a>
      </div>

      {/* Scroll hint */}
      <div className="mt-10 animate-bounce text-gray-400">
        ↓ Scroll to explore
      </div>
    </section>
  );
};

export default Hero;
